import { CHILD_PAGE_NAME } from './types'

const INITIAL_STATE = {
  child_page_name: '',
}

const childPageNameReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CHILD_PAGE_NAME:
      return {
        ...state,
        child_page_name: action.payload,
      }
    default:
      return state
  }
}

export default childPageNameReducer
